import type React from 'react';

/**
 * Shared frosted-glass treatment for pinned surfaces that scrolling content shows
 * through — used by Card's `glassFooter` and WizardLayout's `footerGlass` so the
 * two read identically in both themes.
 *
 * Solid fallback first; the translucent color-mix `background` below overrides it
 * where supported, so the surface never ends up fully transparent (unreadable) if
 * color-mix isn't.
 */
export const GLASS_SURFACE_STYLE: React.CSSProperties = {
    backgroundColor: 'var(--malachite-card-sunken-background)',
    background: 'color-mix(in srgb, var(--malachite-card-sunken-background) 38%, transparent)',
    backdropFilter: 'blur(24px) saturate(180%)',
    WebkitBackdropFilter: 'blur(24px) saturate(180%)',
};
